import Image from "next/image";
import GoogleLogin, { GoogleLoginResponse } from "react-google-login";

import { SocialSignUpType } from "../../../../api/types/social.type";
import { UserData } from "../../../../api/types/user.type";
import { getUser } from "../../../../api/users/getMe";
import { loginSocial } from "../../../../api/users/login";
import { translationsContent } from "../../../../localization/translations";
import { useLanguage } from "../../../../store/lang.context";
import { useUser } from "../../../../store/user.context";
import imageLoader from "../../../../utils/loader";
import { translate } from "../../../../utils/translate";
import classes from "./googleButton.module.scss";

interface Props {
  setSocialSignUp: React.Dispatch<React.SetStateAction<SocialSignUpType>>;
  setLoginIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setSignUpIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setError?: React.Dispatch<React.SetStateAction<boolean>>;
}

const GoogleButton = ({
  setSocialSignUp,
  setLoginIsOpen,
  setSignUpIsOpen,
  setError,
}: Props) => {
  const { language } = useLanguage();
  const { setUser } = useUser();
  const getUserData = (data: UserData | undefined) => {
    setUser(data);
  };
  const responseGoogle = (
    response: GoogleLoginResponse | { code: string; accessToken?: string }
  ) => {
    if (response.accessToken)
      loginSocial({
        provider: "google-oauth2",
        access_token: response.accessToken,
      }).then((res) => {
        if (res.success)
          getUser().then((res2) => {
            if (res2.data?.phone_number === "") {
              setSocialSignUp({
                id: res2.data?.id,
                open: true,
              });
              setLoginIsOpen(false);
              setSignUpIsOpen(false);
            } else {
              setLoginIsOpen(false);
              setSignUpIsOpen(false);
              getUserData(res2.data);
            }
          });
        else {
          if (setError) setError(true);
        }
      });
  };
  return (
    <GoogleLogin
      clientId={process.env.NEXT_PUBLIC_GOOGLE_LOGIN_ID + ""}
      onSuccess={responseGoogle}
      onFailure={responseGoogle}
      render={(renderProps) => (
        <button
          className={classes.button}
          onClick={renderProps.onClick}
          disabled={renderProps.disabled}
        >
          <div className={classes.buttonLogo}>
            <Image
              loader={imageLoader}
              width={"20px"}
              height={"20px"}
              alt="Google +"
              src="googleLogo.svg"
            />
          </div>
          <div className={classes.buttonLabel}>
            {translate(translationsContent, "googleBtn", language)}
          </div>
        </button>
      )}
    />
  );
};

export default GoogleButton;
